import React from "react"
import styled from "styled-components"

import { Container, Row, Col } from "../Grid"
import FormNewsletter from "../FormNewsletter"
import Snippet from "../Snippet"

import { media, mixins } from "../../styles"

import newsletter from "../../images/illustrations/newsletter.svg"

const Wrapper = styled.div`
  background: var(--color-greyLight);
  padding: 50px 0;

  @media ${media.xl} {
    padding: 65px 0;
  }
`

const Illustration = styled.div`
  text-align: center;
  margin: 0 0 30px;

  @media ${media.xl} {
    margin: 0 0 50px;
  }

  img {
    height: auto;
    width: 60px;

    @media ${media.xl} {
      width: 90px;
    }
  }
`

const FormWrapper = styled.div`
  padding: 0 30px;

  h3 {
    ${mixins.title5}
    text-align: center;
  }

  .button {
    display: block;
    margin: 0 auto;
  }

  @media print {
    display: none;
  }
`

const Newsletter = () => {
  return (
    <Wrapper>
      <Container>
        <Illustration>
          <img
            alt="Newsletter"
            aria-hidden="true"
            src={newsletter}
            height="89"
            width="90"
          />
        </Illustration>
        <Row>
          <Col md="10" mdOffset="1" lg="8" lgOffset="2">
            <FormWrapper>
              <h3>
                <Snippet id="homeNewsletter" field="header" />
              </h3>
              <FormNewsletter />
            </FormWrapper>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default Newsletter
